























import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator'
import { VersionInfoRecord } from '@/api/model/user'
import { Date } from '@/utils/filters'
import $Api from '@api'
import Cookie from 'js-cookie'

@Component({
    filters: {
        formatTime(value: string) {
            return Date(value)
        }
    }
})
export default class VersionInfoComponent extends Vue {
    name = 'version-info'
    contentHeight = 0
    versionList: VersionInfoRecord[] = []

    pageQuery = {
        current: 1,
        size: 100,
        pushForeign: 1,
        language: Cookie.get('language') || 'zh'
    }

    @Prop()
    visible!: boolean

    @Emit('cancel')
    onCancel() {
        return true
    }

    @Emit('before-close')
    beforeClose() {
        return true
    }

    created() {
        $Api.userService.queryVersionInfo(this.pageQuery).subscribe(res => {
            this.versionList = res.records
        })
    }

    mounted() {
        this.resizeHandler()
        window.addEventListener('resize', this.resizeHandler)
    }

    resizeHandler() {
        const clientHeight = document.body.clientHeight
        this.contentHeight = clientHeight - 300
    }

    onConfirm() {}
}
